import Reflux from 'reflux'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import keyMirror from 'keymirror'
import 'moment/locale/da'

export const priorities = ['HIGHEST', 'HIGH', 'MEDIUM', 'LOW', 'LOWEST']

export const STATUS = keyMirror({
  IS_FETCHING: null,
  FETCHING_ERROR: null,
  UPDATE_SUCCESS: null,
  UPDATE_ERROR: null,
  DELETE_ERROR: null,
  DELETE_SUCCESS: null,
  TAKING_INPUT: null,
  IS_SAVING: null,
  REDIRECT: null
})

export const ProductTypeActions = Reflux.createActions([
  'getProductTypes',
  'deleteProductType',
  'clearToast',
  'createEmptyProductType',
  'clearFormToast',
  'updateProductTypeField',
  'saveProductType',
  'getProductTypeDetails'
])

export class ProductTypeStore extends Reflux.Store {
  constructor(props) {
    super(props)
    this.listenables = ProductTypeActions
    this.state = {
      status: null,
      productTypes: [],
      productTypeName: null,
      productTypeDetails: {
        name: ''
      },
      groups: []
    }
  }

  getProductTypes() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return
    }

    this.setState({ status: STATUS.IS_FETCHING })
    GET('productTypes/pool').then(responseJSON => {
      let nextState = {
        productTypes: []
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.productTypes = responseJSON
          nextState.status = null
        }
      }
      this.setState(nextState)
    })
  }

  clearToast() {
    this.setState({ status: null })
  }

  deleteProductType(id = null) {
    if (id) {
      POST('productTypes/remove', { ProductTypeID: id }).then(responseJSON => {
        if (responseJSON.error) {
          this.setState({ status: STATUS.DELETE_ERROR })
        } else {
          this.getProductTypes()
        }
      })
    }
  }

  createEmptyProductType() {
    this.setState({
      productTypeDetails: {
        name: ''
      }
    })
  }

  clearFormToast(status) {
    status ? this.setState({ status }) : this.setState({ status: STATUS.TAKING_INPUT })
  }

  getProductTypeDetails(id = null) {
    if (!id) {
      return
    }

    this.setState({ status: STATUS.IS_FETCHING })
    GET('productTypes/fetch', { ProductTypeID: id }).then(responseJSON => {
      let nextState = {
        productTypeDetails: {}
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.productTypeDetails = responseJSON
          nextState.status = STATUS.TAKING_INPUT
        }
      }
      this.setState(nextState)
    })
  }

  updateProductTypeField(field) {
    let fieldName = field.target.name
    let fieldValue
    if (fieldName === 'isActive' || fieldName === 'isHideable') {
      fieldValue = field.target.checked ? 1 : 0
    } else if (fieldName === 'poolOrder') {
      fieldValue = Number(field.target.value)
    } else {
      fieldValue = field.target.value
    }
    let productTypeDetails = this.state.productTypeDetails
    productTypeDetails[fieldName] = fieldValue
    this.setState({ productTypeDetails })
  }

  saveProductType() {
    let productTypeDetails = this.state.productTypeDetails
    if (!productTypeDetails.timeEnd) {
      productTypeDetails.timeEnd = null
    }
    this.setState({ status: STATUS.IS_SAVING })
    POST('productTypes/replace', productTypeDetails).then(responseJSON => {
      if (responseJSON) {
        if (responseJSON.error) {
          this.setState({ status: STATUS.UPDATE_ERROR })
        } else {
          this.setState({ status: STATUS.UPDATE_SUCCESS })
        }
      }
    })
  }
}
